import React, { useState } from "react"
import PropTypes from "prop-types"
import DialogActions from "@material-ui/core/DialogActions"
import DefaultButton from "../DefaultButton"
import Modal from "../Modal"
import useStyles from "./styles"
import { Avatar, CircularProgress, Divider, Typography } from "@material-ui/core"
import { Person } from "@material-ui/icons"
import ContactModal from "../ContactModal"
import api from "../../services/api"
import toastError from "../../errors/toastError"

const ViewContactsModal = ({ open, onClose, contactsCards }) => {
  const classes = useStyles()
  // const { contacts } = useContactsStore() caso queram fazer validaçao de numeros ja adicionados na pagina de contatos {Problema: conseguir fazer essa verificaçao sem fazer muitos fetchs para contatos onde se lida com um grande numero de response}
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [successUpload, setSuccessUpload] = useState([])
  const [errorUpload, setErrorUpload] = useState([])

  const handleSaveAll = async () => {
    setIsSubmitting(true)

    try {
      // Limpar os números de telefone
      const cleanedContactsCards = contactsCards.map((contact) => ({
        ...contact,
        number: String(contact.number || "").replace(/\D/g, ""), // Remove todos os caracteres não numéricos
      }))

      // Array para armazenar os resultados de sucesso e erro
      const successResults = []
      const errorResults = []

      // Iterar sobre cada contato e fazer uma requisição individual
      for (const contact of cleanedContactsCards) {
        try {
          const { data } = await api.post("/contacts", contact) // Envia um contato por vez
          successResults.push(data) // Armazena o resultado bem-sucedido
        } catch (error) {
          errorResults.push({
            contactName: contact.name,
            error: error.response ? error.response.data : error.message,
          }) // Armazena o erro específico do contato
        }
      }

      // Atualiza os estados com os resultados
      setSuccessUpload(successResults)
      setErrorUpload(errorResults)
    } catch (e) {
      toastError(e) // Captura erros gerais
    } finally {
      setIsSubmitting(false)
    }
  }
  const RenderFooter = () => {
    return (
      <DialogActions className={classes.buttonsContainer}>
        <DefaultButton
          stylization="primary"
          className={classes.btnFullWidth}
          onClick={handleSaveAll} // Pass function reference, not invocation
          disabled={isSubmitting}
        >
          {isSubmitting ? <CircularProgress className={classes.circleLoading} /> : "Salvar todos"}
        </DefaultButton>
      </DialogActions>
    )
  }

  const handleClean = () => {
    setSuccessUpload([])
    setErrorUpload([])
  }

  const [contactModalOpen, setContactModalOpen] = useState(false)
  const handleCloseContactModal = () => {
    setContactModalOpen(false)
  }

  const [initialValues, setInitialValues] = useState({ name: "", number: "" })

  return (
    <>
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        initialValues={initialValues}
      />
      <Modal title={`Contatos`} modalOpen={open} onClose={onClose} cleanFunc={handleClean} footer={RenderFooter()}>
        <div>
          <Typography className={classes.titleResult}>Total:{contactsCards.length}</Typography>
          {contactsCards.map((contact, index) => (
            <div
              key={index}
              style={{ border: "1px solid ", marginBottom: 10, padding: 10, borderRadius: 12 }}
              className={classes.contactCard}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {contact.photo ? (
                  <img
                    src={`data:image/jpeg;base64,${contact.photo}`}
                    alt="Contact"
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : contact.name.charAt(0) === "+" || !isNaN(contact.name?.charAt(0)) ? (
                  <Avatar className={classes.avatar}>
                    <Person />
                  </Avatar>
                ) : (
                  <Avatar className={classes.avatar}>{contact.name.charAt(0)}</Avatar>
                )}
                {contact.name.length > 50 ? (
                  <Typography variant="subtitle1" noWrap>
                    {contact.name}
                  </Typography>
                ) : (
                  <Typography variant="subtitle1">{contact.name}</Typography>
                )}
              </div>
              <Typography style={{ display: "flex", alignItems: "center", justifySelf: "center" }} variant="body2">
                {contact.number}
              </Typography>
              <Divider style={{ marginTop: 5, marginBottom: 5 }} />
              <DefaultButton
                stylization={"contact"}
                onClick={() => {
                  setInitialValues({
                    name: contact.name,
                    number: String(contact.number || "").replace(/\D/g, ""),
                  })
                  setContactModalOpen(true)
                }}
                style={{
                  display: "flex",
                  width: "100%",
                }}
              >
                Salvar contato
              </DefaultButton>
            </div>
          ))}
        </div>
        {successUpload.length > 0 && (
          <div className={classes.cSuccessContacts}>
            <Typography className={classes.titleResult}>Adicionados:</Typography>
            {successUpload.map((contact, index) => {
              return <div key={index}>{contact.name} - Contato salvo</div>
            })}
          </div>
        )}
        {errorUpload.length > 0 && (
          <div className={classes.cErrorContacts}>
            <Typography className={classes.titleResult}>Erros:</Typography>
            <ul>
              {errorUpload.map((contact, index) => {
                return (
                  <li key={index}>
                    {contact.contactName} -{" "}
                    {(typeof contact.error === "object" ? contact.error?.error : contact.error) ===
                    "ERR_DUPLICATED_CONTACT"
                      ? "Contato já existente"
                      : (typeof contact.error === "object" ? contact.error?.error : contact.error) ||
                        "Erro desconhecido"}
                  </li>
                )
              })}
            </ul>
          </div>
        )}
      </Modal>
    </>
  )
}

ViewContactsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contactsCards: PropTypes.array.isRequired,
}

export default ViewContactsModal
